
import singleSimDetailType from "../../actions/singleSimDetail/singleSimDetailType";

const initialState = {
    simDetail:[],
    loading: false,
    error: false,
    errorMessage:'',
    //quiz
    quizDetail: null,
    quizLoading: false,
    quizError: false,
    quizErrorMessage:'',
    //exercise
    exerciseDetail: null,
    exerciseLoading: false,
    exerciseError: false,
    exerciseErrorMessage:'',

}

const singleSimDetailReducer=( state = initialState, action) => {


switch(action.type) {
case  singleSimDetailType.START_FETCHING_SINGLE_SIM_DETAILS:
    return{
        ...state,
        simDetail:[],
        loading : true,
        error: false
    }
case  singleSimDetailType.SUCCESS_FETCHIED_SINGLE_SIM_DETAILS :
    return{
        ...state,
        loading : false,
        simDetail: action.payload,
        error: false
    }
case  singleSimDetailType.FAILURE_FETCHED_SINGLE_SIM_DETAILS:
    return{
        ...state,
        loading : false,
        simDetail:[],
        error:true,
        errorMessage:action.errorMessage
    }


//exercise
    case  singleSimDetailType.START_FETCHING_EXERCISE_DETAILS :
        return{
            ...state,
            exerciseDetail: null,
            exerciseLoading: true,
            exerciseError: false,
            exerciseErrorMessage:'',
        }
    case  singleSimDetailType.SUCCESS_FETCHIED_EXERCISE_DETAILS :
        return{
            ...state,
            exerciseDetail: action.payload,
            exerciseLoading: false,
            exerciseError: false,
            exerciseErrorMessage:'',
        }
    case  singleSimDetailType.FAILURE_FETCHED_EXERCISE_DETAILS :
        return{
            ...state,
            exerciseDetail: null,
            exerciseLoading: false,
            exerciseError: true,
            exerciseErrorMessage:action.errorMessage,
            
        }



        
//quiz
    case  singleSimDetailType.START_FETCHING_QUIZ_DETAILS :
        return{
            ...state,
            quizDetail: null,
            quizLoading: true,
            quizError: false,
            quizErrorMessage:'',
        }
    case  singleSimDetailType.SUCCESS_FETCHIED_QUIZ_DETAILS:
        return{
            ...state,
            quizDetail: action.payload,
            quizLoading: false,
            quizError: false,
            quizErrorMessage:'',
        }
    case  singleSimDetailType.FAILURE_FETCHED_QUIZ_DETAILS :
        return{
            ...state,
            quizDetail: null,
            quizLoading: false,
            quizError: true,
            quizErrorMessage:action.errorMessage,
            
        }




    default: return state;
}

}


export default singleSimDetailReducer